import type { AnyAction } from 'redux';
import type { MyFavoriteArticlesState } from 'types/store';

const initialState = (): MyFavoriteArticlesState => {
  return { articles: [], total: 0, purchaseListId: '' };
};

const myFavoriteArticlesReducer = (
  state: MyFavoriteArticlesState = initialState(),
  action: AnyAction,
) => {
  const { type, payload } = action;

  switch (type) {
    case 'ADD_FAVORITE_ARTICLE':
      return {
        ...state,
        articles: [...state.articles, payload.article],
        total: state.total + 1,
      };

    case 'REMOVE_FAVORITE_ARTICLE':
      const updatedArticles = state.articles.filter(
        x => x.id !== payload.article.id,
      );
      return { ...state, articles: updatedArticles, total: state.total - 1 };

    case 'LOAD_MY_FAVORITE_ARTICLES':
      return {
        ...state,
        articles: payload.articles,
        total: payload.total,
        purchaseListId: payload.purchaseListId,
      };

    case 'CLEAR_MY_FAVORITE_ARTICLES':
      return initialState();

    default:
      return state;
  }
};

export default myFavoriteArticlesReducer;
